import 'firebase/database';
import 'firebase/functions';
import * as firebase from 'firebase/app';
import 'firebase/auth'

import { nodeEnvIsTest } from './helpers/functions'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATA_BASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
};


firebase.initializeApp(firebaseConfig);
const rtdb = firebase.database();
const functions = firebase.functions();
const server_value = firebase.database.ServerValue;

if(nodeEnvIsTest()){
  firebase.functions().useFunctionsEmulator('http://localhost:5001');
}

export {
  rtdb,
  firebase,
  functions,
  server_value
}
